// Journey API service.
//
// Talks to the Laravel Admin Journeys endpoint so the User App's journey
// list/detail flow is driven by Admin-configured data instead of the
// hardcoded journeysData.js list. Requests go through apiClient so they
// carry the Dealzta bearer token when one is stored.

import { fetchJson } from './apiClient';

/**
 * Fetch the full journey list from the Laravel Admin API
 * (GET /admin/journeys). Resolves to the raw array of journey objects on
 * success (may be empty), throws on a genuine API/network failure.
 */
export async function getJourneys() {
  const data = await fetchJson('/journeys');
  return Array.isArray(data) ? data : [];
}

/**
 * Fetch journeys and reduce them to what the User App shows: only active
 * journeys, in the order the API returned them (Laravel already orders by
 * created_at desc — no additional/invented ordering field is applied here).
 */
export async function getActiveJourneys() {
  const journeys = await getJourneys();
  return journeys.filter((journey) => journey.active === true);
}

/**
 * The single journey (or null) currently live for a given location. Admin
 * enforces "only one active journey per location" server-side (activating
 * one deactivates every other journey at that location_id), so this can
 * never resolve to more than one journey — it's just "which one, if any".
 */
export async function getActiveJourneyForLocation(locationId) {
  if (locationId == null || locationId === '') return null;
  const journeys = await getActiveJourneys();
  return journeys.find((journey) => String(journey.location_id) === String(locationId)) ?? null;
}
